import React, { useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import FormPopup from "FormModal/FormModal";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import { deleteSystemPromptsAPI } from "Api/systemPromptsAPI";
import { consoleLog } from "helpers";

const Progress = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { setFormData, initialFormState, setFetchSystemPrompts } =
    useGlobalContext();

  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    const response = await deleteSystemPromptsAPI(
      {
        id: props.cell.row.original.id,
      },
      () => {},
      token
    );
    if (response) {
      toast.success(`System prompt deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchSystemPrompts(true);
    }

    if (!response) {
      toast.error("Prompt deletion failed");
    }

    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    setIsFormOpen(true);

    const selectedRow = props.cell?.row?.original;

    setFormData(
      selectedRow
        ? {
            ...selectedRow,
            status: selectedRow.status ? "active" : "inactive",
            category: selectedRow.category || "",
          }
        : {
            ...initialFormState,
            status: initialFormState.status ? "active" : "inactive",
            category: initialFormState.category || "",
          }
    );
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
  };

  const handleFormSubmit = (formData) => {
    consoleLog(["Form submitted:", formData]);
  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="h-5 w-5 cursor-pointer fill-amber-900"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="h-5 w-5  cursor-pointer fill-amber-900"
        onClick={handleDeleteClick}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />

      <FormPopup
        isOpen={isFormOpen}
        onClose={handleFormClose}
        onSubmit={handleFormSubmit}
        isEditMode={true}
        initialFormData={props.cell?.row?.original}
      />
    </div>
  );
};

export default Progress;
